export default {
  setAppSettings(state, settings) {
    state.app.settings = settings || [];
  }
};
